module.exports = __webpack_public_path__ + "static/fish-10-655eb93bc0f642012e4a136398ffee67.jpg";